export default "__VITE_ASSET__41cy5qRl__"